createSafeModule('app.financeiro', [
    'ui.router',
    'ngResource',
    'lazyLoad'
]);